import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const tabBtn = (active) => ({
    padding: '8px 16px',
    margin: '0 4px',
    cursor: 'pointer',
    border: 'none',
    borderBottom: active ? '2px solid #1677ff' : '2px solid transparent',
    background: 'none',
    color: active ? '#1677ff' : '#555',
    fontWeight: active ? 600 : 400,
});

const Login = () => {
    const [method, setMethod] = useState('password'); // 'password' | 'otp'

    // password method
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    // otp method
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false);

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onLoginSuccess = (data) => {
        document.cookie = `token=${data.token}; path=/;`;
        localStorage.setItem('rbacUser', JSON.stringify({ username: data.username, email: data.email, role: data.role }));
        navigate('/dashboard');
    };

    // ── Method A: username + password ──────────────────────────────────────────
    const handlePasswordLogin = async () => {
        if (!username || !password) {
            alert('Please enter your username and password.');
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.post('/admin/login', { username, password });
            onLoginSuccess(data);
        } catch (error) {
            alert(error.response?.data?.message || 'Login failed! Check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    // ── Method B: email OTP ──────────────────────────────────────────────────────
    const handleRequestOtp = async () => {
        if (!email) {
            alert('Please enter your email.');
            return;
        }
        setLoading(true);
        try {
            await api.post('/admin/request-otp', { email });
            setOtpSent(true);
            alert(`An OTP has been sent to ${email}.`);
        } catch (error) {
            alert(error.response?.data?.message || 'Failed to send OTP.');
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async () => {
        if (!otp) {
            alert('Please enter the OTP sent to your email.');
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.post('/admin/verify-otp', { email, otp });
            onLoginSuccess(data);
        } catch (error) {
            alert(error.response?.data?.message || 'OTP verification failed.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>Admin Login</h1>

            <div style={{ marginBottom: 20 }}>
                <button style={tabBtn(method === 'password')} onClick={() => setMethod('password')}>
                    Password
                </button>
                <button style={tabBtn(method === 'otp')} onClick={() => setMethod('otp')}>
                    Email OTP
                </button>
            </div>

            {method === 'password' && (
                <>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        style={{ margin: '10px', padding: '10px' }}
                    />
                    <br />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handlePasswordLogin()}
                        style={{ margin: '10px', padding: '10px' }}
                    />
                    <br />
                    <button onClick={handlePasswordLogin} disabled={loading} style={{ padding: '10px 20px', cursor: 'pointer' }}>
                        {loading ? 'Logging in…' : 'Login'}
                    </button>
                </>
            )}

            {method === 'otp' && (
                <>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={otpSent}
                        onKeyDown={(e) => e.key === 'Enter' && !otpSent && handleRequestOtp()}
                        style={{ margin: '10px', padding: '10px' }}
                    />
                    <br />
                    {!otpSent ? (
                        <button onClick={handleRequestOtp} disabled={loading} style={{ padding: '10px 20px', cursor: 'pointer' }}>
                            {loading ? 'Sending OTP…' : 'Send OTP'}
                        </button>
                    ) : (
                        <>
                            <input
                                type="text"
                                placeholder="OTP"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && handleVerifyOtp()}
                                style={{ margin: '10px', padding: '10px' }}
                            />
                            <br />
                            <button onClick={handleVerifyOtp} disabled={loading} style={{ padding: '10px 20px', cursor: 'pointer' }}>
                                {loading ? 'Verifying…' : 'Verify & Login'}
                            </button>
                            <br />
                            <button
                                onClick={handleRequestOtp}
                                style={{ marginTop: '12px', background: 'none', border: 'none', color: '#1677ff', cursor: 'pointer' }}
                            >
                                Resend OTP
                            </button>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default Login;
